<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M27.008 14.355L6.726 4.22a1.845 1.845 0 00-2.078.225 1.859 1.859 0 00-.54 2.036L7.474 16l-3.366 9.518v.001a1.864 1.864 0 00.54 2.036 1.848 1.848 0 002.078.224l20.282-10.134.023-.011.017-.01A1.855 1.855 0 0028 16a1.863 1.863 0 00-.992-1.645zM9.242 15l-3.13-8.85L25.825 16 6.11 25.85 9.241 17h6.092a1 1 0 100-2H9.242z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsPaperPlaneRightOutline'
}
</script>
